var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.highThreshold") } },
    [
      _c("el-input-number", {
        staticClass: "hide-spin-button",
        staticStyle: { width: "100%" },
        attrs: { min: _vm.optionModel.lowThreshold, max: _vm.optionModel.max },
        model: {
          value: _vm.optionModel.highThreshold,
          callback: function ($$v) {
            _vm.$set(_vm.optionModel, "highThreshold", $$v)
          },
          expression: "optionModel.highThreshold",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }